import styled from 'styled-components'

export const Container = styled.div`
  .header {
    font: normal normal bold 16px/20px Inter;
    color: ${props => props.theme.colors.color2d3139};
    font-weight: bold;
  }
  .timestamp {
    margin-top: 5px;
    span {
      font-size: 12px;
      color: ${props => props.theme.colors.color6b7786};
    }
  }
`
